import React, { useContext, useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import useListEvents from "../services/eventService";
import EventContext from "../store/event-context";
import Alert from '@mui/material/Alert';
import appTheme from '../appTheme';
import { ThemeProvider } from '@mui/material/styles'

const EventList = () => {
  const { eventData, isLoadingEvent, eventServerError } = useListEvents();
  const [showAlert, setShowAlert] = useState(true)
  //const classes = useStyles();
  const eventctx = useContext(EventContext);
  const hasEvents = eventData && eventData.events && eventData.events.length >= 1

  const selectEventHandle = (event) => {
    if (event) {
      console.log("Setting event: " + event);
      eventctx.setEvent(event);
    }
  };

  useEffect(() => {
    //console.log("call useEffect inside EventList...")
    if (eventctx.eventId === "" && hasEvents && eventData.events.length === 1) {
      eventctx.setEvent(eventData.events[0])
    }
  }, [eventData, eventctx.eventId]);


  useEffect(() => {
    setShowAlert(true)
  }, [isLoadingEvent, setShowAlert])


  return (
    <ThemeProvider theme={appTheme}>
    <div>
      {eventctx.eventId === "" && hasEvents && eventData.events.length > 1 && (
        <Dialog open={(eventctx.eventId === "" && hasEvents && eventData.events.length > 1)} >
          <DialogTitle sx={{fontSize: 26 }}>Selecteer het evenement</DialogTitle>
          <List >
            {eventData.events.map((event, index) => (
              <ListItem key={index} button onClick={() => selectEventHandle(event)}>
                <Paper elevation={3} sx={{backgroundColor: 'background.paper', width: '100%', pb: '20px'}}>
                  <Container disableGutters sx={{width: '100%' }} >
                  <Typography gutterBottom sx={{textAlign: 'center', fontSize: 18, backgroundColor: 'primary.main', color: 'text.light', width: '100%', px: '10px'}}>
                  {event.name}
                  </Typography>
                  <Typography variant="body1" sx={{ px: '10px', textAlign: 'center' }}>
                  {event.date}
                  </Typography>
                  <Typography variant="body1" sx={{ px: '10px', textAlign: 'center' }}>
                  {event.location}
                  </Typography> 
                  </Container>
                </Paper>               
              </ListItem>
            ))}
          </List>
        </Dialog>
      )}
      {eventServerError && showAlert && <Alert onClose={() => {setShowAlert(false)}} severity="error">{eventServerError}</Alert>}
    </div>
    </ThemeProvider>
  );
};

export default EventList;
